module.exports = __webpack_public_path__ + "img/logo_green_fund.287a7fa9.jpg";